import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Box, Center } from "@chakra-ui/react";
import BreadcrumbComponent from "../../components/BreadcrumbComponent/BreadcrumbComponent";
import c from "../../constant"
import { gql, useLazyQuery } from '@apollo/client';
import useStore from '../../store';
import MonthlyTimesheet from "../../components/Employee/MonthlyTimesheet"
import { useLocation } from 'react-router-dom';

const Q_GET_EMPLOYEE_BY_ID = gql`
	query get($id: String!) {
		getEmployeeById(id: $id) {
			id
			uid
		}
	}
`;

function TimeSheet() {
    const { t } = useTranslation();
    const { currentUser } = useStore((state) => state.currentUser);
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const id = urlParams.get('id') ? urlParams.get('id') : null;

    const [getEmployeeInformation, { error: errorEmployeeInformation, data: dataEmployeeInformation, loading: loadingEmployeeInformation }] =
    useLazyQuery(Q_GET_EMPLOYEE_BY_ID);
    useEffect(() => {
        window.scrollTo(0, 0);
        if(currentUser){
            getEmployeeInformation({ variables: { id } });
        }
    }, [currentUser]);
                
    return (
        <>
            <Container maxW="container.xl" mt="16px" mb="16px">
                <BreadcrumbComponent
                    list={[
                        {
                            name: t("Account"),
                            path: "/account",
                        },
                        {
                            name: t("Time Sheet"),
                            path: "#",
                        }
                    ]}
                />
                <Center mt="5">
                   
                    <Box
                        w="100%"
                        bg="white"
                        borderRadius={c.borderRadius}
                        border="1px solid #dbdbdb"
                        boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
                        pb="32px"
                    >
                        {dataEmployeeInformation?.getEmployeeById?.uid&&<MonthlyTimesheet uid={dataEmployeeInformation?.getEmployeeById?.uid}/>}
                    </Box>
                </Center>
            </Container>
        </>
    );
}

export default TimeSheet;
